// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Slot from 'shared/editor/Slot';
import useLazyLoad from 'shared/hooks/useLazyLoad';
import type { $Slot } from 'shared/templates/types';
import SlideRightFadeIn from 'shared/transitions/SlideRightFadeIn';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type TemplateSetting = {
  pageTitle: string
}

type Props = {
  slots: $Slot[],
  templateSettings: TemplateSetting,
  classes: Object,
  widgetPresets: [],
  path: string
}

const HeaderFlexContent = (props: Props) => {
  const {
    slots, templateSettings, classes: c, widgetPresets, path
  } = props;

  const { ref, isIntersectingElement } = useLazyLoad();

  return (
    <div ref={ref}>
      <div className={c.menu}>
        <Slot id="menu-bar" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <div className={c.container}>
        <div className={c.titleContainer}>
          <SlideRightFadeIn show={isIntersectingElement}>
            <h1 className={c.title}>{templateSettings.pageTitle}</h1>
          </SlideRightFadeIn>
        </div>
        <Slot id="content" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <footer id="footer" className={c.footer}>
        <Slot id="footer" slots={slots} widgetPresets={widgetPresets} path={path} />
      </footer>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1595px',
    margin: 'auto'
  },
  menu: {
    width: '100%',
    position: 'relative',
    zIndex: '10'
  },
  titleContainer: {
    position: 'relative'
  },
  title: {
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: '40px',
    fontWeight: 300,
    padding: '134px 36px 54px',
    margin: 0,
    '@media(max-width: 570px)': {
      fontSize: '35px'
    }
  },
  footer: {
    width: '100%'
  }
};

export default withThemeProvider(injectSheet(styles)(HeaderFlexContent));
